import axios from 'axios'
import { StepId } from './utils'
import {
  ExpiredCodeError,
  InvalidCodeError,
  ServiceUnavailableError,
  InternalError,
} from '../verificar-codigo/lib/errors'
import { EmailAlreadyExistsError } from '../verificar-email/lib/errors'
import { CreateUserError } from '../datos-personales/lib/errors'

export const http = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL}/v1/onboarding`,
  headers: {
    'Content-Type': 'application/json',
  },
  // withCredentials: true,
})

export class OnboardingService {
  static async executeStep(step, payload) {
    try {
      const response = await http.post(`/execute`, { step, payload })
      return response.data
    } catch (error) {
      if (step === StepId.VERIFICATION_CODE) {
        const errorMap = {
          410: new ExpiredCodeError(),

          400: new InvalidCodeError(),

          422: new InvalidCodeError(),

          500: new ServiceUnavailableError(),
        }

        const status = error.response?.status

        if (errorMap[status]) {
          throw errorMap[status]
        }
      } else if (step === StepId.VERIFY_EMAIL) {
        const errorMap = {
          422: new EmailAlreadyExistsError(),

          500: new InternalError(),
        }

        const status = error.response?.status

        if (errorMap[status]) {
          throw errorMap[status]
        }
      } else if (step === StepId.DATOS_PERSONALES) {
        const errorMap = {
          400: new CreateUserError(),

          500: new InternalError(),
        }

        const status = error.response?.status

        if (errorMap[status]) {
          throw errorMap[status]
        }
      }
      throw error
    }
  }

  static async verify(id) {
    try {
      const response = await http.post(`/verify`, { id })
      return response.data
    } catch (error) {
      console.error('OnboardingService verify error:', error)
      throw error
    }
  }
}
